import React from 'react';
import Icon from '../../../components/AppIcon';

const RequirementsSection = () => {
  const requirements = [
    {
      id: 1,
      title: "Age Range",
      description: "18-30 years old",
      details: "Open to young adults who are passionate about service and leadership development",
      icon: "User",
      color: "text-primary"
    },
    {
      id: 2,
      title: "Meeting Attendance",
      description: "75% attendance minimum",
      details: "Regular participation in monthly meetings and quarterly planning sessions",
      icon: "Calendar",
      color: "text-secondary"
    },
    {
      id: 3,
      title: "Service Commitment",
      description: "20+ hours annually",
      details: "Active participation in club service projects and community initiatives",
      icon: "Heart",
      color: "text-accent"
    },
    {
      id: 4,
      title: "Professional Attitude",
      description: "Commitment to excellence",
      details: "Maintain professional standards in all club activities and communications",
      icon: "Award",
      color: "text-primary"
    }
  ];

  const expectations = [
    {
      category: "Time Commitment",
      items: [
        "Monthly general meetings (2 hours)",
        "Committee meetings as needed (1-2 hours monthly)",
        "Service project participation (4-8 hours monthly)",
        "Social and networking events (optional but encouraged)"
      ]
    },
    {
      category: "Financial Responsibilities",
      items: [
        "Annual membership dues: LKR 2,500",
        "Project contributions as able (no minimum required)",
        "Event participation fees (subsidized for members)",
        "Optional Leo International convention attendance"
      ]
    },
    {
      category: "Leadership Opportunities",
      items: [
        "Committee chair positions available after 6 months",
        "Executive board nominations after 1 year",
        "Project leadership roles based on interest and capacity",
        "Mentorship opportunities for new members"
      ]
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
            Membership Requirements
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We maintain high standards to ensure our members can make meaningful contributions while achieving personal and professional growth.
          </p>
        </div>

        {/* Core Requirements */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {requirements.map((requirement) => (
            <div key={requirement.id} className="bg-card rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-smooth">
              <div className="space-y-4">
                <div className="flex justify-center">
                  <div className="w-16 h-16 bg-surface rounded-full flex items-center justify-center">
                    <Icon name={requirement.icon} size={24} className={requirement.color} />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-foreground mb-2">{requirement.title}</h3>
                  <p className="text-primary font-semibold mb-2">{requirement.description}</p>
                  <p className="text-sm text-muted-foreground leading-relaxed">{requirement.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Detailed Expectations */}
        <div className="grid lg:grid-cols-3 gap-8">
          {expectations.map((section, index) => (
            <div key={index} className="bg-surface rounded-xl p-8">
              <h3 className="text-xl font-bold text-foreground mb-6 flex items-center">
                <Icon 
                  name={index === 0 ? "Clock" : index === 1 ? "DollarSign" : "Star"} 
                  size={20} 
                  className="text-primary mr-3" 
                />
                {section.category}
              </h3>
              <ul className="space-y-3">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start space-x-3">
                    <Icon name="ArrowRight" size={16} className="text-accent mt-1 flex-shrink-0" />
                    <span className="text-sm text-foreground leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RequirementsSection;